import { YStack, Spinner } from '@my/ui';
import { TZABrandGuidelines } from '@my/util';

export const LoadingView = () =>{
  return <YStack style={{
    width: '100%', heights: '100%', 
    alignItems: 'center', justifyContent: 'center'
  }}>
    <Spinner size="large" color={TZABrandGuidelines.colorsMap.primaryGreen} /> 
  </YStack>
}